import type { ProductProps } from 'tsconfig/types';
import { priceAndPointConverter } from '../../../../utils';

interface Props {
  product: ProductProps | null;
  upsellProduct: ProductProps | null;
  upsellSelected: boolean;
}

export const ProductPricing = (props: Props) => {
  const { product, upsellProduct, upsellSelected } = props;
  const salePrice = product?.skus[0].salePrice;
  const rrp = product?.skus[0].buyersRRP ?? 0;
  const upsellSale = upsellProduct?.skus[0].salePrice ?? 0;
  const upsellRRP = upsellProduct?.skus[0].buyersRRP ?? 0;

  if (!salePrice || salePrice <= 0) {
    return null;
  }

  const totalRRP = upsellSelected ? upsellRRP + rrp : rrp;
  const totalSale = upsellSelected ? upsellSale + salePrice : salePrice;

  return (
    <div className="mcs-price">
      {rrp > 0 && <s className="product-price__original h8">{priceAndPointConverter(totalRRP)}</s>}
      <span className="product-price-sale h8">{priceAndPointConverter(totalSale)}</span>
    </div>
  );
};
